import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { ButtonBarComponent, ClickableDirective, TooltipDirective } from '@blaze-shared/shared-ui';

import { AvailabilityScheduleConfig } from '../../availability.model';
import { DatesRangePickerComponent } from '../../components/dates-range-picker/dates-range-picker.component';

@Component({
  selector: 'blaze-availability-schedule-header',
  templateUrl: './availability-schedule-header.component.html',
  styleUrls: ['./availability-schedule-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIconModule,
    ClickableDirective,
    MatSlideToggleModule,
    DatesRangePickerComponent,
    ButtonBarComponent,
    TooltipDirective,
  ],
  host: { class: 'flex gap-8 bg-bat-complementary p-4 pl-16 items-center rounded' },
})
export class AvailabilityScheduleHeaderComponent {
  config = input.required<AvailabilityScheduleConfig>();
  isFirst = input.required<boolean>();
  isExpanded = input.required<boolean>();
  canSave = input.required<boolean>();
  hasErrors = input.required<boolean>();
  hasMissingConfig = input.required<boolean>();
  ruleErrors = input.required<Record<string, string>>();

  saveChanges = output();
  toggleRules = output();
  copySchedule = output();
  deleteSchedule = output();
  updateConfig = output<AvailabilityScheduleConfig>();

  hasAnyTimeSlots = computed(() => {
    return !!this.config().rules.length && this.config().rules.some((r) => !!r.timeSlots.length);
  });

  saveTooltip = computed(() => {
    if (this.hasMissingConfig()) {
      return 'Config is incomplete';
    }
    if (!this.hasAnyTimeSlots()) {
      return 'Add slots to save';
    }
    return undefined;
  });

  protected onDatesChanged(event: { since: string | null; until: string | null }): void {
    this.updateConfig.emit({
      ...this.config(),
      since: event.since,
      until: event.until,
    });
  }
}
